import { TimePhasingApiConnector } from "../shared/connector/TimePhasingApiConnector";
import { handleCommonError } from "./helper/DefaultErrorHandler";

const tryMakingRequest = async <X>(
  fn: () => Promise<X>,
  useDefaultErrorHandler: boolean = true
) => {
  try {
    return await fn?.();
  } catch (error: any) {
    if (useDefaultErrorHandler) {
      handleCommonError(error);
    }
    throw error;
  }
};

export const getDataAsync = async <T = any>(
  routeName: string,
  useDefaultErrorHandler = true
) => {
  return await tryMakingRequest(async () => {
    const response = await TimePhasingApiConnector.get(routeName);
    return response.data as T;
  }, useDefaultErrorHandler);
};

export const postDataAsync = async <P, T>(
  routeName: string,
  data: P,
  useDefaultErrorHandler: boolean = true
) => {
  return await tryMakingRequest(async () => {
    const response = await TimePhasingApiConnector.post(routeName, data);
    return response.data as T;
  }, useDefaultErrorHandler);
};
